import { render, staticRenderFns } from "./color.vue?vue&type=template&id=fbcff0f6&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports